module.exports = __webpack_public_path__ + "img/total-guest.7540e372.svg";